import { keysFromObject } from "../../utils/keysFromObject.mjs";
import { LOCALE_CODES } from "./index.mjs";
export const useI18nNumberFormats = () => {
  const getCurrencyByLocale = (locale) => {
    const { EN, DE_CH, FR_CH, IT_CH, EN_US } = LOCALE_CODES;
    if (locale === EN) {
      return "GPB";
    }
    if (locale === EN_US) {
      return "USD";
    }
    if ([DE_CH, FR_CH, IT_CH].includes(locale)) {
      return "CHF";
    }
    return "EUR";
  };
  return keysFromObject(LOCALE_CODES).reduce(
    (acc, localeKey) => {
      const localeValue = LOCALE_CODES[localeKey];
      acc[localeValue] = {
        currency: {
          style: "currency",
          currency: getCurrencyByLocale(localeValue),
          currencyDisplay: "symbol"
        },
        percent: {
          style: "percent"
        }
      };
      return acc;
    },
    {}
  );
};
